import React from 'react';
import WheelOfChores from '../../pages/WheelOfChores/WheelOfChores';
import './MobileApp.css';

function MobileApp() {
  return (
    <div className="wheel-mobile-app-shell">
      <WheelOfChores initialExperienceMode="phone" showModeSwitch={false} />
    </div>
  );
}

export default MobileApp;
